import { ProductDataSourceUID } from "@ehealth_tools/common-payment/src/data/product.config";
import { PaymentDataSourceUID } from "@ehealth_tools/common-payment/src/datasources/paymentDataSources";
import { UsersDataSourceUID } from "@ehealth_tools/common/src/data/user/user.ds";
import { CommonDataSourceUID } from "@ehealth_tools/common/src/datasources/commonDataSources";
import { HealthCheckDataSourceUID } from "./data/healthCheck/healthCheck.ds";
import { OnapsDataSourceUid } from "./data/onaps/onaps.ds";
/** Datasource UIDs a pseudo enum */
export const DataSourceUID =
{
    ...CommonDataSourceUID,
    ...ProductDataSourceUID,
    ...PaymentDataSourceUID,
    ...UsersDataSourceUID,
    ...HealthCheckDataSourceUID,
    ...OnapsDataSourceUid,
    USER_PROGRAM: "USER_PROGRAM"
};

export type DataSourceUIDType = typeof DataSourceUID[keyof typeof DataSourceUID] & string;